import { render, staticRenderFns } from "./_footerWebsite.vue?vue&type=template&id=5879e9ee&"
import script from "./_footerWebsite.vue?vue&type=script&lang=js&"
export * from "./_footerWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports